<div class="app" [dir]="languageService.getLanguage === 'ar' ? 'rtl' : 'ltr'">

  <!-- Authentication Pages (Login/Forget Password) - No Layout -->
  <ng-container *ngIf="isAuthPage">
    <app-main-content></app-main-content>
  </ng-container>

  <!-- Main Application with Layout -->
  <ng-container *ngIf="!isAuthPage">
    <!-- Hidden on screens that scroll their own container: the document is already at the top
         there, so the button would do nothing when pressed. -->
    <button
      *ngIf="!hasOwnScrollContainer"
      (click)="goTop()"
      id="GoTop"
      [title]="'shared.goToTop' | translate">
      <i class="fas fa-chevron-up"></i>
    </button>
    <div class="wrapper">
      <!-- Sidebar (only when authenticated) -->
      <ng-container *ngIf="currentUser && !isUserManagement">
        <msn-side-bar [Refresh]="refresh" class="hide-p"></msn-side-bar>
      </ng-container>
      <ng-container *ngIf="currentUser && isUserManagement">
        <system-code-side-bar [Refresh]="refresh" class="hide-p"></system-code-side-bar>
      </ng-container>

      <!-- Navbar -->
      <app-nav-bar *ngIf="currentUser" class="hide-p"></app-nav-bar>

      <!-- Main Content Area -->
      <div AddsRtl id="main-wrapper" class="main-wrapper full">
        <div class="main-content-wrapper">
          <app-main-content></app-main-content>
        </div>
      </div>
    </div>
  </ng-container>

</div>
<p-toast />